import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Search,
  Zap,
  Heart,
  Palette,
  Columns3,
  Settings,
  Activity,
} from 'lucide-react';
import './Sidebar.css';

interface SidebarProps {
  active: string;
  onNavigate: (page: string) => void;
}

const navItems = [
  { id: 'dashboard', label: 'Dashboard', Icon: LayoutDashboard },
  { id: 'search', label: 'Busca', Icon: Search },
  { id: 'activity', label: 'Atividade', Icon: Zap },
  { id: 'watchlists', label: 'Watchlists', Icon: Heart },
  { id: 'themes', label: 'Temas', Icon: Palette },
  { id: 'compare', label: 'Comparar', Icon: Columns3 },
  { id: 'admin-analyses', label: 'Análises (admin)', Icon: Activity },
  { id: 'settings', label: 'Configurações', Icon: Settings },
];

export default function Sidebar({ active, onNavigate }: SidebarProps) {
  const navigate = useNavigate();

  const handleNavClick = (id: string) => {
    onNavigate(id);
    const routes: Record<string, string> = {
      dashboard: '/dashboard',
      search: '/search',
      activity: '/activity',
      watchlists: '/watchlists',
      themes: '/themes',
      compare: '/compare',
      'admin-analyses': '/admin/analyses',
      settings: '/settings',
    };
    navigate(routes[id] || '/dashboard');
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <span className="logo-dot">●</span>
          <span className="logo-text">Radar</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        <div className="nav-section-label">NAVEGAÇÃO</div>
        {navItems.map((item) => {
          const IconComponent = item.Icon;
          return (
            <button
              key={item.id}
              className={`nav-item ${active === item.id ? 'active' : ''}`}
              onClick={() => handleNavClick(item.id)}
              title={item.label}
            >
              <IconComponent size={14} className="nav-icon" />
              <span className="nav-label">{item.label}</span>
            </button>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <div className="user-profile">
          <div className="user-avatar">MR</div>
          <span className="user-name">M. Ribeiro</span>
        </div>
      </div>
    </aside>
  );
}
